export default __webpack_public_path__ + "static/media/RealCase-en.c2d16866.png";